import { Client } from "@/Common/Api/Client";
import { IObstetricaLabResultOption, IObstetricaLabResultsGroup, LabObservationObstetricalFile } from "@/Common/Api/Labs/Dto/Responses/LabMessageGroupDTO";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { ObstetricalFileType } from "@/Patient/Models/ObstetricalFile/Enum/ObstetricalFileType";
import { BaseObstetricalLabResultHandler } from "./BaseObstetricalLabResultHandler";

class BritishColumbiaObstetricaLabResultHandler extends BaseObstetricalLabResultHandler {
    public get relevantStandardCodes(): { [key: string]: IObstetricaLabResultOption } {
        return this.getRelevantCodes();
    }

    public async getlabs(contactId: string): Promise<IObstetricaLabResultsGroup[]> {
        const response = await Client.postAsync<any>(
            ServerOperations.Server.Myle_Patient_MedicalNote_GetLabResultsObstetricalFile,
            {
                PatientContactId: contactId,
                ObstetricalFileType: ObstetricalFileType.BritishColumbiaForm
            }
        );

        if (!response.isSuccess) {
            sessionStore.showPopup(response.errors);
            return;
        }

        return (response.data?.ObstetricalFileLabResult as LabObservationObstetricalFile[])
            ?.filter(r => this.relevantStandardCodes[r.ObservationStandardCode] != null)
            .sortByProperty(r => this.relevantStandardCodes[r.ObservationStandardCode].index)
            .groupBy(p => p.ObservationStandardCode)
            .map(item => ({
                key: item[0].ObservationStandardCode,
                values: item.sortByPropertyDesc(p => p.CollectionDate),
                options: this.relevantStandardCodes[item[0].ObservationStandardCode]
            }) as IObstetricaLabResultsGroup
            );
    }

    private getRelevantCodes(): { [key: string]: IObstetricaLabResultOption; } {
        return {
            "Medfar_BcAntenatal_Rubella": { index: 0, displayTrimester: false },
            "Medfar_BcAntenatal_HIV": { index: 1, displayTrimester: false },
            "Medfar_BcAntenatal_Syphilis": { index: 2, displayTrimester: false },
            "Medfar_BcAntenatal_HBsAg": { index: 3, displayTrimester: false },
            "Medfar_BcAntenatal_Gonorrhea": { index: 4, displayTrimester: false },
            "Medfar_BcAntenatal_Chlamydia": { index: 5, displayTrimester: false },
            "Medfar_BcAntenatal_UrineC&S": { index: 6, displayTrimester: false },
            "Medfar_BcAntenatal_GBS": { index: 7, displayTrimester: false },
            "Medfar_BcAntenatal_Other": { index: 8, displayTrimester: false }
        };
    }
}

export { BritishColumbiaObstetricaLabResultHandler };
